// account-ui catalog — locale de (register: Du, informal).
import en from './en';

const de: typeof en = {
  common: {
    loading: 'Laden…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'Dein lumi-HR-Konto',
      intro:
        'Diese Seite gehört dir, nicht einem Workspace. Sie bleibt erreichbar, auch wenn ein Workspace, zu dem du gehörst, gesperrt oder geschlossen ist.',
      rightsTitle: 'Was du hier tun kannst',
      rights: {
        takeout: 'Eine Kopie deiner Daten herunterladen, sobald sie für dich bereitliegt.',
        erasure:
          'Die Löschung eines Workspace und seiner Daten beantragen oder einen Antrag zurückziehen, den du selbst gestellt hast.',
        invoices: 'Die Rechnungen eines Workspace ansehen und herunterladen, den du verwaltest.',
        export: 'Einen Workspace exportieren, der dir gehört – alle Daten in einem verschlüsselten Archiv.',
      },
      signInHint:
        'Für all das musst du dich zuerst anmelden. Ein Link, den wir dir per E-Mail schicken, verweist nur auf diese Seite – er meldet dich nie an.',
      workspaceHint:
        'Alles andere – deine tägliche Arbeit und deine Einstellungen – bleibt in deinem Workspace.',
    },
    signIn: {
      title: 'Anmelden',
      intro:
        'Nimm deine lumi-HR-E-Mail-Adresse und dein Passwort. Du musst keinen Workspace angeben – wir zeigen dir die, zu denen du gehörst.',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      submit: 'Anmelden',
      failed: 'Mit dieser E-Mail-Adresse und diesem Passwort konnten wir dich nicht anmelden.',
      passkey: 'Mit Passkey anmelden',
      passkeyHint:
        'Keine E-Mail-Adresse? Ein Konto, das mit einer Handynummer eingerichtet wurde, meldet sich mit seinem Passkey an.',
      passkeyFailed: 'Mit diesem Passkey konnten wir dich nicht anmelden.',
      operatorSecondFactor: 'Das ist ein Systemadmin-Konto, das einen zweiten Faktor braucht. Melde dich hier mit einem Passkey an; mit Passwort und Authenticator-Code meldest du dich in der lumi-Konsole an.',
    },
    session: {
      signedInAs: 'Angemeldet als {email}.',
      signOut: 'Abmelden',
    },
    workspaces: {
      title: 'Deine Workspaces',
      intro:
        'Die Workspaces, zu denen du gehörst. Ein gesperrter Workspace bleibt in dieser Liste – genau dafür ist diese Seite da.',
      emptyTitle: 'Keine Workspaces',
      emptyBody:
        'Dieses Konto gehört zu keinem Workspace. Wenn du hier einen erwartet hast, frag die Person, die dich eingeladen hat.',
      loadFailed: 'Wir konnten deine Workspaces nicht laden.',
      ssoRequired:
        'Dieser Workspace verlangt Unternehmens-SSO. Melde dich über den Workspace selbst an, um diese Funktionen zu nutzen – mit einem Passwort geht das hier nicht.',
      state: {
        active: 'Aktiv',
        suspended: 'Gesperrt',
        provisioning: 'Wird eingerichtet',
        erased: 'Gelöscht',
        unavailable: 'Nicht verfügbar',
      },
      hint: {
        active: 'Dieser Workspace läuft normal.',
        suspended: 'Dieser Workspace ist gesperrt. Deine Rechte kannst du hier trotzdem wahrnehmen.',
        provisioning: 'Dieser Workspace wird noch eingerichtet.',
        erased:
          'Dieser Workspace und seine Daten wurden gelöscht. Nur die Rechnungen bleiben, weil wir sie aufbewahren müssen.',
        unavailable: 'Dieser Workspace ist derzeit nicht erreichbar.',
      },
    },
    invoices: {
      open: 'Rechnungen anzeigen',
      hide: 'Rechnungen ausblenden',
      empty: 'Für diesen Workspace gibt es keine Rechnungen.',
      loadFailed: 'Die Rechnungen dieses Workspace konnten wir nicht laden.',
      download: 'PDF herunterladen',
      documentMissing: 'Zu dieser Rechnung gibt es kein Dokument zum Herunterladen.',
      documentUnavailable:
        'Das Rechnungsdokument lässt sich gerade nicht abrufen. Es ist weiterhin vorhanden – versuch es bitte gleich noch einmal.',
      downloadFailed: 'Diese Rechnung konnten wir nicht herunterladen.',
    },
    takeout: {
      title: 'Die Kopie deiner Daten',
      what:
        'Das ist eine Kopie der personenbezogenen Daten, die dieser Workspace über dich gespeichert hat, samt einer Erläuterung, wofür sie verwendet werden.',
      availableUntil:
        'Bis zum {date} kannst du sie herunterladen. Danach wird sie automatisch gelöscht – speichere sie vorher ab, wenn du sie behalten möchtest.',
      download: 'Meine Daten herunterladen',
      none: 'Hier liegt gerade keine Kopie deiner Daten für dich bereit.',
      expired:
        'Die für dich erstellte Kopie ließ sich bis zum {date} herunterladen. Inzwischen wurde sie gelöscht, wie angekündigt.',
      howToAsk:
        'Eine Kopie kannst du jederzeit anfordern: Wende dich an den Workspace, der deine Daten hat. Sobald sie bereitliegt, schicken wir dir eine E-Mail, und du lädst sie auf dieser Seite herunter.',
      loadFailed: 'Wir konnten nicht prüfen, ob eine Kopie deiner Daten für dich bereitliegt.',
      downloadUnavailable:
        'Deine Kopie lässt sich gerade nicht abrufen. Sie ist weiterhin vorhanden – versuch es bitte gleich noch einmal.',
      downloadFailed: 'Die Kopie deiner Daten konnten wir nicht herunterladen.',
    },
    export: {
      title: 'Diesen Workspace exportieren',
      intro:
        'Lade alles aus diesem Workspace als ein verschlüsseltes Archiv herunter. Das geht auch, während der Workspace gesperrt ist – genau dafür ist diese Seite da.',
      contents:
        'Im Archiv stecken die Daten aller Personen, jede Datei, die in den Workspace hochgeladen wurde, und seine Verbindungen zu anderen Diensten. Behandle es wie den Workspace selbst: bewahre es sicher auf und gib es niemandem, der nicht alles sehen darf. Das Archiv enthält außerdem für Personal, Recruiting und Zeit je ein HR Open Standards (HR-JSON)-Dokument — das gemeinsame Format, falls du zu einem anderen Anbieter wechselst.',
      passphraseWarning:
        'Die Passphrase wählst du, und wir speichern sie nie. Ohne sie lässt sich das Archiv nicht mehr öffnen – weder von dir noch von uns.',
      passphraseLabel: 'Passphrase für das Archiv',
      passphraseHint: 'Mindestens {min} Zeichen.',
      confirmLabel: 'Passphrase wiederholen',
      submit: 'Export starten',
      started:
        'Der Export läuft. Die Vorbereitung dauert eine Weile – komm auf diese Seite zurück und aktualisiere die Liste.',
      errorTooShort: 'Wähle eine Passphrase mit mindestens {min} Zeichen.',
      errorMismatch: 'Die beiden Passphrasen stimmen nicht überein. Prüf sie und versuch es noch einmal.',
      errorCannotStart:
        'Der Export kann gerade nicht gestartet werden – möglicherweise läuft für diesen Workspace bereits einer, oder der Workspace wird gerade geschlossen.',
      errorTooMany:
        'Dieser Workspace hat heute so viele Exporte gestartet, wie er darf. Versuch es bitte morgen wieder.',
      errorGeneric:
        'Der Export ließ sich nicht starten. Es wurde nichts geändert – versuch es bitte gleich noch einmal.',
      listTitle: 'Exporte dieses Workspace',
      refresh: 'Aktualisieren',
      loadFailed: 'Die Exporte dieses Workspace konnten wir nicht laden.',
      empty: 'Von diesem Workspace wurde noch kein Export erstellt.',
      startedAt: 'Gestartet am {date}',
      availableUntil: 'Herunterladbar bis {date}',
      download: 'Archiv herunterladen',
      downloadGone: 'Dieses Archiv gibt es nicht mehr. Starte einen neuen Export, um wieder eines zu bekommen.',
      downloadUnavailable:
        'Das Archiv lässt sich gerade nicht abrufen. Es ist weiterhin vorhanden – versuch es bitte gleich noch einmal.',
      downloadFailed: 'Das Archiv konnten wir nicht herunterladen.',
      status: {
        requested: 'In der Warteschlange',
        exporting: 'Wird vorbereitet',
        exported: 'Zum Herunterladen bereit',
        failed: 'Fehlgeschlagen',
        expired: 'Gelöscht',
        unknown: 'Status unbekannt',
      },
    },
    erasure: {
      file: 'Löschung dieses Workspace beantragen',
      loadFailed: 'Wir konnten nicht prüfen, ob für diesen Workspace eine Löschung beantragt wurde.',
      confirmTitle: 'Löschung dieses Workspace beantragen?',
      confirmWhatGoes:
        'Alles in „{workspace}“ würde endgültig gelöscht: jede Personalakte, jede Bewerbung, jedes Dokument, jede Zeitbuchung und jede Einstellung – für alle, die darin arbeiten. Zurückholen lässt sich davon nichts mehr.',
      confirmProcess:
        'Du stellst einen Antrag, gelöscht wird noch nichts. Wir prüfen ihn, und nach der Freigabe beginnt eine Wartefrist. Bis die Löschung tatsächlich startet, kannst du den Antrag jederzeit zurückziehen.',
      invoicesKept: 'Die Rechnungen bleiben, weil wir sie gesetzlich aufbewahren müssen.',
      reason: 'Grund (optional)',
      keep: 'Nein, Workspace behalten',
      confirmSubmit: 'Ja, Löschung beantragen',
      pendingReview: 'Für diesen Workspace wurde die Löschung beantragt. Wir prüfen den Antrag.',
      pendingUntil: 'Für diesen Workspace wurde die Löschung beantragt. Er wird nach dem {date} gelöscht.',
      paymentsPending:
        'Dieser Workspace ist zur Löschung vorgemerkt, weil das Konto nicht bezahlt wurde.',
      paymentsPendingUntil:
        'Dieser Workspace ist zur Löschung vorgemerkt, weil das Konto nicht bezahlt wurde. Er wird nach dem {date} gelöscht.',
      paymentsSettle:
        'Wenn die offene Rechnung bezahlt wird, stoppt diese Löschung. Du kannst die Löschung auch selbst beantragen – dann läuft sie unabhängig von der Zahlung weiter.',
      paymentsCannotWithdraw:
        'Diese Löschung wurde vorgemerkt, weil das Konto nicht bezahlt wurde; hier lässt sie sich deshalb nicht zurückziehen. Bezahl die offene Rechnung, um sie zu stoppen.',
      confirmTakeover:
        'Dieser Workspace ist bereits zur Löschung vorgemerkt, weil das Konto nicht bezahlt wurde. Dein Antrag übernimmt diese Löschung: Eine Zahlung stoppt sie danach nicht mehr.',
      withdraw: 'Löschantrag zurückziehen',
      withdrawTitle: 'Löschantrag zurückziehen?',
      withdrawBody:
        'Dieser Workspace und alle Daten bleiben erhalten. Du kannst die Löschung jederzeit erneut beantragen.',
      confirmType: 'Tippe zur Bestätigung den Workspace-Namen ({name}) ein',
      confirmMismatch:
        'Der eingegebene Name passt nicht zu diesem Workspace. Prüf ihn bitte und versuch es noch einmal.',
      tooLate: 'Die Löschung läuft bereits und lässt sich nicht mehr zurückziehen.',
      conflict: 'Dieser Workspace wird bereits gelöscht, es hat sich nichts geändert.',
      nothingOpen: 'Für diesen Workspace gibt es keinen Löschantrag, den man zurückziehen könnte.',
      filed: 'Dein Löschantrag ist eingegangen. Wir prüfen ihn.',
      withdrawn: 'Der Löschantrag wurde zurückgezogen. Dieser Workspace bleibt bestehen.',
    },
    closure: {
      title: 'Dein lumi-Konto schließen',
      intro:
        'Hier geht es um dein lumi-Konto selbst – deine Anmeldung – und nicht um einen der Workspaces oben.',
      open: 'Mein Konto schließen',
      confirmTitle: 'Dein lumi-Konto schließen?',
      whatGoes:
        'Deine Anmeldung verschwindet: Diese E-Mail-Adresse und dieses Passwort funktionieren nicht mehr, eine verknüpfte Unternehmensanmeldung wird getrennt, und du verlässt jeden Workspace, zu dem du gehörst. Was du selbst bei lumi getan hast, geht mit: Wir löschen deine Gespräche mit dem Assistenten, die Benachrichtigungen, die wir dir geschickt haben, und deine Einstellungen dazu – und aus den Support-Anfragen und Nachrichten, die du uns geschrieben hast, nehmen wir deinen Namen und deine Texte heraus.',
      whatStays:
        'Deine Daten bei den einzelnen Arbeitgebern bleiben bei diesen Arbeitgebern. lumi betreibt die Systeme, verantwortlich für seine Personal- und Bewerbungsdaten bleibt aber jedes Unternehmen selbst – die Schließung hier löscht diese Daten nicht. Und wenn es zu einem Workspace einen Rechtsstreit oder eine behördliche Untersuchung gibt, müssen wir aufbewahren, was dazugehört: Deine Anfragen, Nachrichten und Gespräche aus diesem Workspace bleiben dann, bis das erledigt ist.',
      howToErase:
        'Wenn du die Löschung der Daten möchtest, die ein Arbeitgeber über dich hat, wende dich bitte direkt an das jeweilige Unternehmen. Es entscheidet selbst darüber, und einen Teil davon muss es gesetzlich noch eine Weile aufbewahren.',
      noUndo:
        'Die Schließung lässt sich nicht rückgängig machen, und es wird nichts für dich offengehalten. Du kannst dich jederzeit mit derselben E-Mail-Adresse neu registrieren – dabei entsteht ein neues, leeres Konto.',
      confirmType: 'Tipp zur Bestätigung deine E-Mail-Adresse ({email}) ein',
      confirmMismatch:
        'Das ist nicht die E-Mail-Adresse dieses Kontos. Bitte prüf sie und versuch es noch einmal.',
      keep: 'Nein, Konto behalten',
      confirmSubmit: 'Ja, Konto schließen',
      doneTitle: 'Dein Konto ist geschlossen',
      doneBody:
        'Du bist abgemeldet, und mit dieser E-Mail-Adresse und diesem Passwort ist bei lumi keine Anmeldung mehr möglich. Deine Gespräche mit dem Assistenten und die Benachrichtigungen, die wir dir geschickt haben, sind gelöscht, und in den Support-Anfragen und Nachrichten, die du uns geschrieben hast, stehen dein Name und deine Texte nicht mehr.',
      doneStays:
        'Deine Daten bei den einzelnen Arbeitgebern bleiben bei diesen Arbeitgebern und werden weiterhin von ihnen verwaltet. Für deren Löschung wende dich bitte direkt an das jeweilige Unternehmen. Und wenn es zu einem Workspace einen Rechtsstreit oder eine behördliche Untersuchung gibt, bleibt bei uns, was dazugehört – so lange, bis das erledigt ist.',
      doneMailed: 'Wir haben dir eine Bestätigung per E-Mail geschickt.',
      doneNotMailed:
        'Wir konnten dir die Bestätigungs-E-Mail nicht schicken. Dein Konto ist trotzdem geschlossen.',
      blockedTitle: 'Diese Workspaces brauchen noch eine Inhaberin oder einen Inhaber',
      blockedBody:
        'Bei den folgenden Workspaces bist du die einzige Inhaberin bzw. der einzige Inhaber, deshalb können wir dein Konto noch nicht schließen. Einen Workspace ohne Inhaber können nur wir wieder öffnen, und alle, die darin arbeiten, kämen nicht mehr an ihre eigenen Daten.',
      blockedTransfer:
        'Übergib „{name}“: Öffne diesen Workspace und übertrage die Inhaberschaft dort an ein anderes Mitglied.',
      blockedErasure:
        'Oder beantrage die Löschung von „{name}“ in der Liste deiner Workspaces oben.',
      blockedReturn:
        'Dieser Versuch wird nicht vorgemerkt. Sobald dich kein Workspace mehr als Inhaber braucht, komm auf diese Seite zurück und schließ dein Konto dann.',
      unavailable:
        'Das Schließen von Konten funktioniert gerade nicht. Geändert wurde nichts – versuch es bitte gleich noch einmal.',
      alreadyClosed: 'Dieses Konto ist bereits geschlossen.',
      failed:
        'Das hat nicht geklappt. Dein Konto wurde nicht geschlossen – versuch es bitte gleich noch einmal.',
      confirmTypePhone: 'Tipp zur Bestätigung deine vollständige Handynummer ({phone}) ein',
      confirmMismatchPhone:
        'Das ist nicht die Handynummer dieses Kontos. Bitte prüf sie und versuch es noch einmal.',
      whatGoesPhone:
        'Deine Anmeldung verschwindet: Deine Passkeys und diese Handynummer funktionieren nicht mehr, eine verknüpfte Unternehmensanmeldung wird getrennt, und du verlässt jeden Workspace, zu dem du gehörst. Was du selbst bei lumi getan hast, geht mit: Wir löschen deine Gespräche mit dem Assistenten, die Benachrichtigungen, die wir dir geschickt haben, und deine Einstellungen dazu – und aus den Support-Anfragen und Nachrichten, die du uns geschrieben hast, nehmen wir deinen Namen und deine Texte heraus.',
      noUndoPhone:
        'Die Schließung lässt sich nicht rückgängig machen, und es wird nichts für dich offengehalten. Ein Workspace kann dich jederzeit mit derselben Nummer neu einladen – dabei entsteht ein neues, leeres Konto.',
      doneBodyPhone:
        'Du bist abgemeldet, und mit deinen Passkeys und dieser Handynummer ist bei lumi keine Anmeldung mehr möglich. Deine Gespräche mit dem Assistenten und die Benachrichtigungen, die wir dir geschickt haben, sind gelöscht, und in den Support-Anfragen und Nachrichten, die du uns geschrieben hast, stehen dein Name und deine Texte nicht mehr.',
      doneScreenOnly: 'Diese Seite ist deine Bestätigung – per SMS schicken wir keine.',
    },
  },
};

export default de;
